import React from "react";
import { LocalStorageProvider } from "./stores/localstorage";
import { CookieStorageProvider } from "./stores/cookiestorage";
import { SessionStorageProvider } from "./stores/sessionstorage";
export const StoreWrapper = ({ children }) => {
    return (React.createElement(LocalStorageProvider, null,
        React.createElement(SessionStorageProvider, null,
            React.createElement(CookieStorageProvider, null, children))));
};
//# sourceMappingURL=wrap-root-element.js.map